import { render, staticRenderFns } from "./PolicyList.vue?vue&type=template&id=ce577e3a&"
import script from "./PolicyList.vue?vue&type=script&lang=js&"
export * from "./PolicyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce577e3a')) {
      api.createRecord('ce577e3a', component.options)
    } else {
      api.reload('ce577e3a', component.options)
    }
    module.hot.accept("./PolicyList.vue?vue&type=template&id=ce577e3a&", function () {
      api.rerender('ce577e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/PolicyList.vue"
export default component.exports